<div class="shm-heading">
    <div class="k-d-inline-flex">
        <h2 class="k-mb-6">
            Cancel Meeting(s)
        </h2>
    </div>
</div>
<form class="" [formGroup]="form">
    <div>
        <div class="contact-details k-my-4">
            <div class="k-d-flex k-justify-content-stretch">
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                    <kendo-grid [data]="gridData" [selectable]="selectableSettings" [navigable]="true" [height]="300">
                        <kendo-grid-checkbox-column>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" size="medium" kendoCheckBox
                                    [disabled]="checkIfDisabled(dataItem)"
                                    (change)="handleSelectionChange($event,dataItem)" />
                            </ng-template>
                        </kendo-grid-checkbox-column>
                        <kendo-grid-column field="meetingName" title="Meeting Name"></kendo-grid-column>
                        <kendo-grid-column field="location" title="Location"></kendo-grid-column>
                        <kendo-grid-column field="origScheduleDt" title="Date and Time" [format]="'dd/MM/yyyy HH:mm'">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.origScheduleDt | date: 'MM/dd/yyyy HH:mm' }}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
        <div class="contact-details k-my-4">
            <div class="k-d-inline-flex k-mb-2">
                <h3 class="k-m-0">Reason For Meeting Cancellation</h3>
            </div>
            <div class="k-d-flex k-justify-content-stretch">
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                    <kendo-label text="" class="student-document__label"> </kendo-label>
                    <kendo-dropdownlist [data]="reason" [rounded]="'large'" formControlName="reason"
                        [textField]="'description'" [valueField]="'id'" [size]="'medium'"></kendo-dropdownlist>
                </div>
            </div>
        </div>

        <div class="contact-details k-my-4" *ngIf="showAddInformation">
            <div class="k-d-inline-flex ">
                <h3 class="k-m-0">Additional Information</h3>
            </div>

            <div class="k-d-flex k-justify-content-stretch">
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                    <kendo-label text="" class="student-document__label"> </kendo-label>
                    <kendo-formfield class="!k-mt-0" showHints="always">
                        <kendo-textarea placeholder="Type here" formControlName="otherReason"
                            class="student-document__textarea" [rows]="3" resizable="vertical"></kendo-textarea>
                        <kendo-formerror>Error: Field is mandatory</kendo-formerror>
                    </kendo-formfield>
                </div>
            </div>

        </div>
    </div>
</form>

<div class="page-footer k-mt-2 k-text-right">
    <div class="action-btns">
        <div class="action-btns__right">
            <button kendoButton size="medium" rounded="large" fillMode="outline" themeColor="error"
                (click)="onCancel()">
                Close
            </button>
            &nbsp;
            <button kendoButton themeColor="primary" (click)="submit()" size="medium" rounded="large"
                [disabled]="gridData?.length === 0" fillMode="solid">
                Cancel Selected Meeting(s)
            </button>
        </div>
    </div>
</div>